import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import './style/style.css';
import './style/responsiveness.css';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Form from './components/Form';
import HOME from "./pages/HOME";
import ABOUTUS from "./pages/ABOUTUS";
import OUTDOOR from './pages/OUTDOOR';
import INDOOR from './pages/INDOOR';
import RESTURANT from './pages/RESTURANT';
import PACKAGES from './pages/PACKAGES';
import NEWS from './pages/NEWS';
import EVENTS from './pages/EVENTS';
import CONTACT from "./pages/CONTACTUS";
import MEMBERSHIP from "./pages/MEMBERSHIP";

function App() {
  const location = useLocation();
  const hideForm = location.pathname === "/contact";

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<HOME />} />
        <Route path="/about" element={<ABOUTUS />} />
        <Route path="/outdoor" element={<OUTDOOR />} />
        <Route path="/indoor" element={<INDOOR />} />
        <Route path="/hotel-restaurant" element={<RESTURANT />} />
        <Route path="/packages" element={<PACKAGES />} />
        <Route path="/news" element={<NEWS />} />
        <Route path="/events" element={<EVENTS />} />
        <Route path="/contact" element={<CONTACT />} />
        <Route path="/membership" element={<MEMBERSHIP />} />
      </Routes>
      {!hideForm && <Form />}
      <Footer />
    </>
  );
}

export default function WrappedApp() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
